import { createSelector } from 'reselect';

const selectInbox = (state: any) => state.inbox;


export const selectInboxCurrentItem = createSelector([selectInbox], (inbox) => inbox.current);

export const selectInboxListItems = createSelector([selectInbox], (inbox) => inbox.list);

export const selectInboxItemById = (itemId: any) =>
    createSelector(selectInboxListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectInboxQueryItems = createSelector([selectInbox], (inbox) => inbox.query);

export const selectInboxCreatedItem = createSelector([selectInbox], (inbox) => inbox.create);
export const selectInboxPublishedItem = createSelector([selectInbox], (inbox) => inbox.publish);

export const selectInboxUpdatedItem = createSelector([selectInbox], (inbox) => inbox.update);

export const selectInboxReadItem = createSelector([selectInbox], (inbox) => inbox.read);

export const selectInboxDeletedItem = createSelector([selectInbox], (inbox) => inbox.delete);

export const selectInboxSearchedItems = createSelector([selectInbox], (inbox) => inbox.search);

export const selectInboxItemsCount = createSelector([selectInbox], (inbox) => inbox.count);

export const selectInboxItemsFilter = createSelector([selectInbox], (inbox) => inbox.filter);